export default class lang {
    Langs = ['JA'];
    Text:texts;

    constructor(lang:number){
        this.Text = langs[lang];
    }
}


const langs:Array<texts> = [
    {
        appTitle:"電子給与明細",
        manualA:"操作マニュアル",
        loginTitle:"ログイン",
        logout:"ログアウト",
        chgPassword:"パスワード変更",
        setTotp:"ワンタイムパスワードの設定",
        userId:"ユーザーID",
        userName:"名前",
        shimei:"氏名",
        pCode:"社員番号",
        password:"パスワード",
        otpCode:"ワンタイムパスワード",
        authFail:"ログイン情報が間違っています",
        authLock:"あなたのログイン試行はロックされました",
        authUnLock:"しばらく待ってからやり直ししてください",
        confn:"確認",
        yes:"はい",
        no:"いいえ",
        ok:"OK",
        close:"閉じる",
        cancel:"キャンセル",
        secretKey:"シークレットキー",
        unknowDef:"不明",
        noSelectData:"表示可能なデータがありません",
        withholdingTax:"源泉徴収票",
        yendAdj:"年末調整還付金",
        print:"印刷",
        otpActive:"有効",
        new:"新",
        serch:"検索",
        depertment:"所属",
        update:"更新",
        numlic:"数値",
        year:"年",
        warekiNen:"和暦(年)",
        warekiShortNen:"(S,H,R)+年",
        month:"月",
        day:"日",
        passwordRule:"8文字以上設定してください",
        passwordRuleScore:"複雑なパスワードにしてください",
        today:"今日",
        birthDay:"生年月日",
        gengou:"元号",
        isEnterYear:"当年就職",
        enter:"就職",
        isRetireUear:"当年退職",
        retire:"退職",
        warning:"警告",
        loading:"Loading...",
        uploading:"アップロード中...",
        payColmun:{
            salary:"給与",
            salaryPeriodText:"%Y 年%M 月",
            bonus:"賞与",
            bonusPeriodText:"%Y 年%S ",
            yend:"年末調整等",
            yendPeriodText:"%Y 年",
            resignation:"給与辞令",
        },
        functionName:{
            passwordChange:"パスワードの変更",
            currentPassword:"現在のパスワード",
            newPassword:"新しいパスワード",
            newPasswordV:"新しいパスワード(確認)",
            setTopt:"ワンタイムパスワード設定",
            totpSet:"ワンタイムパスワード設定",
            totpCl:"ワンタイムパスワード解除",
        },
        administrator:{
            title:"管理画面",
            tabUsers:"ユーザー管理",
            addUser:"ユーザー追加",
            noData:"ユーザーが見つかりません",
            confAddUser:"上記情報で追加してよろしいですか？",
            setNewPassword:"パスワードを設定しました",
            reSetPassword:"パスワード再設定",
            confResetPssword:"パスワードを再設定してもよろしいですか？",
            printPdf:"パスワード情報印刷",
            matchData:"データ更新",
            matchDataTxt:"名前・退職状態をTimeProのデータから取得します",
            setAlias:"社員番号移行",
            fixName:"名前設定",
            periodConfig:"表示期間設定",
            viewConfig:"表示項目設定",
            formConfig:"帳票設定",
            titile:"項目名",
            tpDef:"TimePro項目名",
            calc:"計算",
            getPdf:"PDF確認",
            pdfUpload:"PDFアップロード",
            disTmpPdf:"PDF破棄",
            preview:"プレビュー",
            spouse:{
                name:"配偶者氏名",
                kana:"配偶者氏名(カナ)",
                living:"配偶者住居区分",
                birthday:"配偶者誕生日",
            },
            dependentChild:{
                name:"16歳未満扶養親族氏名",
                kana:"16歳未満扶養親族氏名(カナ)",
                living:"16歳未満扶養親族住居区分",
                birthday:"16歳未満扶養親族誕生日",
            },
            dependentOther:{
                name:"扶養親族氏名",
                kana:"扶養親族氏名(カナ)",
                living:"扶養親族住居区分",
                birthday:"扶養親族誕生日",
            },
            period:{
                saralyView:"開示対象給与支払日",
                saralyViewHint:"指定日以前支払日の明細を開示します",
                bounusView:"開示対象賞与支払日",
                bounusViewHint:"指定日以前支払日の明細を開示します",
                yendView:"年末調整開示年",
                yendViewHint:"指定年以前の明細を開示します",
                saraly:"給与・賞与表示期間(月)",
                retire:"退職者ログイン期間(月)",
                yend:"年末調整表示期間(年)",
            },
            listColumn:{
                userId:"社員番号",
                userId8:"社員番号(8桁)",
                alias:"別番号",
                userName:"名前",
                depertment:"所属",
                empCode:"個人コード",
                isRetire:"退職",
                lastLogin:"最終ログイン",
                useTotp:"OTP",
                resetPassword:"パスワード発行",
            },
            formColumn:{
                defcode:"項目",
                width:"幅",
                height:"高さ",
                pX:"横位置",
                pY:"縦位置",
                fSize:"文字サイズ",
                align:"文字位置",
                previewVal:"プレビュー用"
            },
            option:{
                type:"処理",
                num:"数値",
                tvalue:"値1",
                fvalue:"値2",
            }
        },
        messege:{
            lastLogin:"前回ログイン日時",
            invalidSession:"現在のセッションが無効になりました、再度ログインしてください",
            dbSccess:"処理が完了しました",
            regedUser:"登録済みユーザーです",
            warnMultiUser:"複数のユーザーが見つかりました",
            selectUser:"ユーザーを選択してください",
            dontGetFile:"ファイルの取得に失敗しました",
            setTopt:"ワンタイムパスワードを設定します。<br>設定すると時間生成式のパスワードの入力が追加で必要になり<br>よりセキュリティを高めることができます。<br>設定後自動でログアウトします",
            newPasswordCheckV:"新しいパスワード(確認)が一致していません",
            userNotfound:"ユーザーが見つかりません",
            activateTotp:"正しく登録出来たか確認するためワンタイムパスワードを入力し「確認」をクリックしてください",
            activateComp:"正常に登録されました。「閉じる」で一度ログアウトしますのでワンタイムパスワードを使用しログインしてください",
            activateFail:"ワンタイムパスワードが正しくありません",
            userId8:"社員番号を８桁で入力してください",
            fileLoadFailed:"ファイルの読み込みに失敗しました",
            fileLoadSccess:"ファイルを読み込みました",
            fileAnalazFail:"ファイルの解析に失敗しました",
            addUserColition:"登録済みか社員番号移行移行済みです",
            totpApp:{
                text:"ワンタイムパスワードの生成にはスマートフォンアプリが必要です<br>以下2つのアプリを推奨します<br>※ワンタイムパスワード設定後にアプリに情報を登録するため設定前にインストールしてください",
                google:{
                    name:"Google 認証システム",
                    andoroid_link:`<a href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png' style="border-radius: 13px; width: 200px;"></a>`,
                    iOs_link:`<a href="https://apps.apple.com/jp/app/google-authenticator/id388497605?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px;" target="_blank"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1284940800&h=7fc6b39acc8ae5a42ad4b87ff8c7f88d" alt="Download on the App Store" style="border-radius: 13px; width: 160px;"></a>`,
                },
                microsoft:{
                    name:"Microsoft Authenticator",
                    andoroid_link:`<a href='https://play.google.com/store/apps/details?id=com.azure.authenticator&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'style="border-radius: 13px; width: 200px;"></a>`,
                    iOs_link:`<a href="https://apps.apple.com/jp/app/microsoft-authenticator/id983156458?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px;" target="_blank"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1432944000&h=39686e6a537b2c44ff7ce60f6287e68f" alt="Download on the App Store" style="border-radius: 13px; width: 160px;"></a>`,
                }
            },
            totpInfo:"ワンタイムパスワードを設定しました",
            totpInfoSecret:"アプリにシークレットキーを入力するかQRコードを読み込んでください",
            totpWarnActivate:"ワンタイムパスワードが正しくありません",
            fixName:{
                a:"TimeProのデータとは別の名前を設定します",
                b:"設定後「データ更新」しても名前は更新されません",
                submit:"設定",
                cancel:"解除",
                cancelTxt:"解除後「データ更新」するとTimeProのデータに更新できます"
            },
            setAliasTxt:{
                a:"上記ユーザーを別社員番号へ移行します",
                b:"移行すると新番号で現在の番号の情報が閲覧できます",
                c:"パスワードや安否確認用連絡先の情報も移行します",
                d:"旧番号ではログインできなくなります",
                e:"新社員番号へ移行してよろしいですか？",
            },
            passwordEvaluation:{
                fock:"かなり弱い",
                week:"弱い",
                soso:"そこそこ強い",
                strong:"強い",
                verystrong:"かなり強い",
            },
            resing:{
                remove:"内容をすべて削除してよろしいですか？",
                upload1:"アップロードするファイルを選択してください",
                upload2:"重複データを上書きする",
                upload3:"アップロードする",
                uploadDateA:"適用年月",
                uploadDateR:"交付日",
                uploadCount:"%count 件のデータを読み込みました",
            },
        },
        taxClomun:{
            yu:"有",
            mu:"無",
            maru:"〇",
            tekiyo:"摘要",
            uti:"内",
            simei:"氏名",
            kubun:"区分",
            ju:"従",
            A1:"住所又は居住",
            A2:"種別",
            A3:"支払金額",
            A4:"給与所得控除後の給与等の金額（調整控除後）",
            A5:"所得控除の額の合計額",
            A6:"源泉徴収税額",
            A7:"（源泉）控除対象配偶者の有無等",
            A8:"配偶者（特別）控除の額",
            A9:"控除対象扶養親族の数",
            A9a:"控除対象扶養親族の数",
            A9b:"老人",
            A9c:"その他",
            A10:"（源泉）控除対象配偶者の有無等",
            A11:"障害者の数",
            A11a:"特別",
            A11b:"その他",
            A12:"社会保険料等の金額",
            A12a:"",
            A12b:"",
            A13:"生命保険料の控除額",
            A14:"地震保険料の控除額",
            A15:"住宅借入金等特別控除の額",
            A16:"「（源泉・特別）控除対象配偶者」及び「控除対象扶養親族」",
            A16a:"（源泉・特別）控除対象配偶者",
            A16b:"配偶者の合計所得",
            A16c:"控除対象扶養者",
            A16d:"16歳未満の控除対象扶養者",
            person:"支払いを受ける者",
            name:"氏名",
            type:"種別",
            many:"支払金額等",
            dependent:"扶養等",
            insurance:"保険等",
        },
        bonusNoStr:{
            0:"特別１",
            1:"夏期",
            2:"特別２",
            3:"冬期",
        },
        errorMessege:{
            0:"想定外のエラーが発生しました",
            1:"サーバーが応答していません",
            101:"重複データがあるため更新できませんでした",
            500001:"データベースの接続できませんでした",
            500002:"データベースの処理に失敗しました",
        },
        resingForm:{
            system:{
                upload:"リストのアップロード",
                remove:"リストの削除",
                formatType:[
                    "使用書式",
                    "P3以下通常",
                    "P3以下出張不可",
                    "P3以下　初任給引上げによる引上げ調整あり",
                    "S4M1カットなし",
                    "S4M1カットあり",
                    "M2M3",
                ],
                jobLevel:"資格等級",
                goubou:"号棒",
                upGobou:"UP号棒",
                bf:"昇給前",
                af:"昇給後",
                bCut:"カット前",
                aCut:"カット後",
                cutRate:"カット率",
                baseSal:"役割給",
                continReword:"勤続給",
                manageReword:"マネジ手当",
                workReword:"業務手当",
                classReword:"系統手当",
                baseUp:"役割給昇給額",
                untrip:"出張不可対象者役割給",
                decereaseNum:"減額分",
                decereaseSal:"減額後支給額",
                fstAdjDetail:"初任給引上げに伴う役割給詳細",
                fstAdjGoboP:"調整号俸ピッチ",
                fstAdjYen:"調整による昇給金額",
                fstAdjGoboU:"号俸　従来の人事制度上の昇給分",
                fstAdjUpSal:"従来の人事制度上の昇給額",
                aDate:"適用月",
                aDateFormat:"%gengou  %year 年 %month 月",
                rDate:"交付日",
                rDateFormat:"%gengou  %year 年 %month 月 %date 日",
            },
            salary:{
                title:"給与辞令",
                userCd:"社員番号",
                simei:"氏名",
                namedono:"%name 　殿",
                singDate:"%gengou %year 年%month 月%date 日",
                singName:"㈱オギハラ",
                messege1a:"%gengou %year 年%month 月分給与より",
                messege1b:"基本給月額%yen 円を支給する。",
                messege2a:"%gengou %year 年%month 月度からの資格等級・基準内賃金は以下の通りとする。",
                messege2b:"※本辞令は対象者本人に発行するものであり、他者への公開を禁ずる。",
                messege2c:"※本辞令交付後に資格等級等に変更があった場合、基準内賃金の見直しを行うものとする。",
                detail:"上記の詳細",
                jobClass:"資格等級",
                gobo:"号棒",
                base:"役割給",
                conti:"勤続給",
                yen:"円",
                yenMark:"￥",
                untripAnnotation:"※出張対応不可による見直し後の金額は以下の通り。",
                untripDetai:"出張対応不可により%gengou %year 年度の役割給支給額は以下の通りとする。",
                untripNum:"減額",
                untripBase:"本来の役割給",
                untripDecereBase:"減額後の役割給支給額",
                fstAdjTblCls:"区分",
                fstAdjTblGob:"号棒",
                fstAdjTblNum:"昇給額",
                fstAdjDetail:"上記役割給　対前年度の昇給額　詳細",
                fstAdjDefUp:"従来の人事制度上の昇給額",
                fstAdjBaseUp:"ベースアップ分",
                fstAdjTotal:"合計",
                mBaseSal:"基準内賃金",
                mTblClmBase:"役割給",
                mTblClmMng:"マネジメント手当",
                mTblClmWrk:"業務手当",
                mTblClmCls:"系統手当",
                mTblClmAll:"計",
                mUntripAnn:"※出張対応不可による見直し後の役割給は以下の通り。",
                cutRate:"減額率",
                mCutRate:"%rate ％",
                mCutMes:"減額後の基準内賃金",
                bfNum:"減額前",
                afNum:"減額後",
            },
        },
        matchUserWarrning:{
            title:"社員情報更新：",
            message1:"※再雇用者がいる場合は先に「社員番号移行」を行ってください。",
            message2:"「社員番号移行」を行わずに処理を続行すると安否確認用連絡先情報が失われます。",
        },
    },
]

export interface texts{
    appTitle:string,
    manualA:string,
    loginTitle:string;
    logout:string;
    chgPassword:string;
    setTotp:string;
    userId:string;
    userName:string;
    shimei:string;
    pCode:string;
    password:string;
    otpCode:string;
    authFail:string;
    authLock:string;
    authUnLock:string;
    confn:string,
    yes:string;
    no:string;
    ok:string;
    close:string;
    cancel:string;
    secretKey:string;
    unknowDef:string;
    noSelectData:string;
    yendAdj:string;
    withholdingTax:string;
    print:string;
    otpActive:string;
    new:string;
    serch:string;
    depertment:string,
    update:string,
    numlic:string,
    year:string,
    warekiNen:string,
    warekiShortNen:string,
    month:string,
    day:string,
    passwordRule:string,
    passwordRuleScore:string,
    today:string,
    birthDay:string,
    gengou:string,
    isEnterYear:string,
    enter:string,
    isRetireUear:string,
    retire:string,
    warning:string,
    loading:string,
    uploading:string,
    payColmun:{
        salary:string;
        salaryPeriodText:string;
        bonus:string;
        bonusPeriodText:string;
        yend:string;
        yendPeriodText:string;
        resignation:string;
    }
    functionName:{
        passwordChange:string;
        currentPassword:string;
        newPassword:string;
        newPasswordV:string;
        setTopt:string,
        totpSet:string;
        totpCl:string;
    },
    administrator:{
        title:string;
        tabUsers:string;
        addUser:string;
        noData:string;
        confAddUser:string;
        setNewPassword:string;
        reSetPassword:string;
        confResetPssword:string;
        printPdf:string,
        matchData:string,
        matchDataTxt:string,
        setAlias:string,
        fixName:string,
        periodConfig:string,
        spouse:{
            name:string,
            kana:string,
            living:string,
            birthday:string,
        },
        dependentChild:{
            name:string,
            kana:string,
            living:string,
            birthday:string,
        },
        dependentOther:{
            name:string,
            kana:string,
            living:string,
            birthday:string,
        },
        period:{
            saralyView:string,
            saralyViewHint:string,
            bounusView:string,
            bounusViewHint:string,
            yendView:string,
            yendViewHint:string,
            saraly:string,
            retire:string,
            yend:string,
        },
        viewConfig:string,
        formConfig:string,
        titile:string,
        tpDef:string,
        calc:string,
        getPdf:string,
        pdfUpload:string,
        disTmpPdf:string,
        preview:string,
        listColumn:{
            userId:string,
            userId8:string,
            alias:string,
            userName:string,
            depertment:string,
            empCode:string,
            isRetire:string,
            lastLogin:string,
            useTotp:string,
            resetPassword:string,
        },
        formColumn:{
            defcode:string,
            width:string,
            height:string,
            pX:string,
            pY:string,
            fSize:string,
            align:string,
            previewVal:string,
        },
        option:{
            type:string,
            num:string,
            tvalue:string,
            fvalue:string,
        }
    },
    messege:{
        lastLogin:string,
        invalidSession:string,
        dbSccess:string,
        regedUser:string,
        warnMultiUser:string,
        selectUser:string,
        dontGetFile:string,
        setTopt:string,
        userNotfound:string,
        newPasswordCheckV:string,
        activateTotp:string,
        activateComp:string,
        activateFail:string,
        userId8:string,
        fileLoadFailed:string,
        fileLoadSccess:string,
        fileAnalazFail:string,
        addUserColition:string,
        totpApp:{
            text:string,
            google:{
                name:string,
                andoroid_link:string,
                iOs_link:string,
            },
            microsoft:{
                name:string,
                andoroid_link:string,
                iOs_link:string
            }
        },
        totpInfo:string,
        totpInfoSecret:string,
        totpWarnActivate:string,
        fixName:{
            a:string,
            b:string,
            submit:string,
            cancel:string,
            cancelTxt:string,
        }
        setAliasTxt:{
            a:string,
            b:string,
            c:string,
            d:string,
            e:string,
        },
        passwordEvaluation:{
            fock:string,
            week:string,
            soso:string,
            strong:string,
            verystrong:string,
        },
        resing:{
            remove:string,
            upload1:string,
            upload2:string,
            upload3:string,
            uploadDateA:string,
            uploadDateR:string,
            uploadCount:string,
        }
    },
    taxClomun:{
        yu:string,
        mu:string,
        maru:string,
        tekiyo:string,
        uti:string,
        simei:string,
        kubun:string,
        ju:string,
        A1:string,
        A2:string,
        A3:string,
        A4:string,
        A5:string,
        A6:string,
        A7:string,
        A8:string,
        A9:string,
        A9a:string,
        A9b:string,
        A9c:string,
        A10:string,
        A11:string,
        A11a:string,
        A11b:string,
        A12:string,
        A12a:string,
        A12b:string,
        A13:string,
        A14:string,
        A15:string,
        A16:string,
        A16a:string,
        A16b:string,
        A16c:string,
        A16d:string,
        person:string,
        name:string,
        many:string,
        type:string,
        dependent:string,
        insurance:string,
    },
    bonusNoStr:{
        [bonusno:number]:string
    },
    errorMessege:{
        [errorCode:number]:string;
    },
    resingForm:{
        system:{
            upload:string,
            remove:string,
            formatType:string[],
            jobLevel:string,
            goubou:string,
            upGobou:string,
            bf:string,
            af:string,
            bCut:string,
            aCut:string,
            cutRate:string,
            baseSal:string,
            continReword:string,
            manageReword:string,
            workReword:string,
            classReword:string,
            baseUp:string,
            untrip:string,
            decereaseNum:string,
            decereaseSal:string,
            fstAdjDetail:string,
            fstAdjGoboP:string,
            fstAdjYen:string,
            fstAdjGoboU:string,
            fstAdjUpSal:string,
            aDate:string,
            aDateFormat:string,
            rDate:string,
            rDateFormat:string,
        },
        salary:{
            title:string,
            userCd:string,
            simei:string,
            singDate:string,
            singName:string,
            namedono:string,
            messege1a:string,
            messege1b:string,
            messege2a:string,
            messege2b:string,
            messege2c:string,
            detail:string,
            jobClass:string,
            gobo:string,
            base:string,
            conti:string,
            yen:string,
            yenMark:string,
            untripAnnotation:string,
            untripDetai:string,
            untripNum:string,
            untripBase:string,
            untripDecereBase:string,
            fstAdjTblCls:string,
            fstAdjTblGob:string,
            fstAdjTblNum:string,
            fstAdjDetail:string,
            fstAdjDefUp:string,
            fstAdjBaseUp:string,
            fstAdjTotal:string,
            mBaseSal:string,
            mTblClmBase:string,
            mTblClmMng:string,
            mTblClmWrk:string,
            mTblClmCls:string,
            mTblClmAll:string,
            mUntripAnn:string,
            cutRate:string,
            mCutRate:string,
            mCutMes:string,
            bfNum:string,
            afNum:string,
        },
    },
    matchUserWarrning:{
        title:string,
        message1:string,
        message2:string,
    }
}
